import React from 'react';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { TieredAccountCell } from 'src/components/enterprise/Parents/Admin/TieredAccountTable/TieredAccountCell/TieredAccountCell';
import { TieredAccountRow } from 'src/components/enterprise/Parents/Admin/TieredAccountTable/TieredAccountRow/TieredAccountRow';
import { RouterLink } from 'src/components/RouterLink/RouterLink';
import { getHomePath } from 'src/constants/urls';

interface ChildAccountRowProps {
  name: string;
  corpId: string;
  firmDesignator: string;
}

export const ChildAccountRow: React.FC<ChildAccountRowProps> = ({
  name,
  corpId,
  firmDesignator,
}) => {
  const homeHref = getHomePath(corpId);

  return (
    <TieredAccountRow>
      <TieredAccountCell width={6}>
        <RouterLink href={homeHref}>{name}</RouterLink>
      </TieredAccountCell>
      <TieredAccountCell width={6}>
        <Copy variant="body">{firmDesignator}</Copy>
      </TieredAccountCell>
    </TieredAccountRow>
  );
};
